<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icons/Outline/chevron-right">
<path id="Vector" d="M9 18L15 12L9 6" stroke="#9FAEC4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
